import { Form, InputNumber, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getLeavePolicyAndAllocation, updateLeaveAllocation } from "../../../redux/rtk/features/user/userSlice";
import getCompanyIdFromToken from "../../../utils/getCompanyIdFromToken";
import BtnEditSvg from "../Button/btnEditSvg";

const LeaveEditPopup = ({ leaveData, id }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const companyId = getCompanyIdFromToken();
    console.log("leaveData", leaveData);
    console.log("id", id);

    const leaveDataArray = leaveData?.data || [];

    useEffect(() => {
        if (isModalOpen && Array.isArray(leaveDataArray)) {
            form.setFieldsValue(
                leaveDataArray.reduce((acc, leave) => {
                    acc[`annualLeave_${leave.id}`] = leave.allocation.annualLeave || 0;
                    return acc;
                }, {})
            );
        }
    }, [isModalOpen, leaveDataArray, form]);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    const onFinish = async (values) => {
        // Prepare the data to send to the backend
        const leaveAllocations = leaveDataArray.map((leave) => ({
            leavePolicyId: leave.id,
            userId: id, // Use the passed id (userId)
            company_id: companyId,
            annualLeave: values[`annualLeave_${leave.id}`] || 0,
        }));

        // Dispatch the action to update leave allocation
        for (const allocation of leaveAllocations) {
            dispatch(updateLeaveAllocation({ values: allocation }));
        }
        toast.success(" Leave Allocation Updated Successfully");
        dispatch(getLeavePolicyAndAllocation({ companyId, id }));



        setIsModalOpen(false); // Close the modal after submission
    };

    // useEffect(() => {
    //     }, [dispatch]);
    return (
        <>
            <button onClick={showModal}>
                <BtnEditSvg size={30} />
            </button>
            <Modal
                title="Edit Leave Information"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    form={form}
                    name="leaveDetails"
                    layout="vertical"
                    onFinish={onFinish}
                >
                    {leaveDataArray.length > 0 ? (
                        leaveDataArray.map((leave) => (
                            <div key={leave.id}>
                                <h4>{leave.name}</h4>
                                <Form.Item
                                    name={`annualLeave_${leave.id}`}
                                    // label="Alloted Leave"
                                    initialValue={leave.allocation.annualLeave}
                                >
                                    <InputNumber />
                                </Form.Item>
                                {/* <Form.Item
                                    name={`monthlyLeave_${leave.id}`}
                                    label="Monthly Leave"
                                    initialValue={leave.allocation.monthlyLeave}
                                >
                                    <InputNumber />
                                </Form.Item> */}
                            </div>
                        ))
                    ) : (
                        <p>No leave data available</p>
                    )}
                    <button type="submit"><bold>Save</bold></button>
                </Form>
            </Modal>
        </>
    );
};

export default LeaveEditPopup;
